import styled from "styled-components";
export const Container = styled.footer`
    width: 100%;
    position: sticky;
    bottom: 0;
    padding: 16px;
    font-size: 12px;
    color: rgb(21, 41, 53);
    letter-spacing: 0.4px;
    text-align: left;
    line-height: 12px;
    font-family: Roboto;
    font-weight: 400;
    border-top: 1px solid #d9d9d9;
    background-color: #ffffff;
    min-height: 70px;
    box-sizing: border-box;
    flex-shrink: 0;
`;
export const Logo = styled.img`
    height: 25px;
    display: inline-block;
    vertical-align: middle;
`;
